import { render, staticRenderFns } from "./v-company-info.vue?vue&type=template&id=29f79084&scoped=true"
import script from "./v-company-info.vue?vue&type=script&lang=js"
export * from "./v-company-info.vue?vue&type=script&lang=js"
import style0 from "./v-company-info.vue?vue&type=style&index=0&id=29f79084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f79084",
  null
  
)

export default component.exports